export const getInitials = (name: string) => {
    const parts = name.trim().split(/\s+/);
    const filteredParts = parts.filter((part) => part.length > 0);
    const initials = filteredParts.slice(0, 2);
    return initials.map((part) => part[0]?.toUpperCase() ?? "").join("");
};
